document.addEventListener('DOMContentLoaded', function () {

  /* ---------------------------------------------------------------
     Helpers
  --------------------------------------------------------------- */
  function formatMoney(cents, format) {
    // Simple fallback formatter; relies on Shopify.money_format if present.
    var value = (cents / 100).toFixed(2).replace('.', ',');
    if (window.Shopify && Shopify.money_format) {
      return Shopify.money_format.replace(/\{\{\s*amount\s*\}\}/, value);
    }
    return '€' + value;
  }

  var overlay = document.querySelector('[data-overlay]');

  function openOverlay() { overlay && overlay.classList.add('is-open'); }
  function closeOverlay() { overlay && overlay.classList.remove('is-open'); }

  /* ---------------------------------------------------------------
     Mobile nav
  --------------------------------------------------------------- */
  var mobileNav = document.querySelector('[data-mobile-nav]');
  var mobileNavOpenBtns = document.querySelectorAll('[data-mobile-nav-open]');
  var mobileNavCloseBtns = document.querySelectorAll('[data-mobile-nav-close]');

  mobileNavOpenBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      mobileNav && mobileNav.classList.add('is-open');
      openOverlay();
    });
  });
  mobileNavCloseBtns.forEach(function (btn) {
    btn.addEventListener('click', closeAll);
  });

  /* ---------------------------------------------------------------
     Cart drawer
  --------------------------------------------------------------- */
  var cartDrawer = document.querySelector('[data-cart-drawer]');
  var cartOpenBtns = document.querySelectorAll('[data-cart-open]');
  var cartCloseBtns = document.querySelectorAll('[data-cart-close]');

  function openCart(e) {
    if (e) e.preventDefault();
    cartDrawer && cartDrawer.classList.add('is-open');
    openOverlay();
  }
  cartOpenBtns.forEach(function (btn) { btn.addEventListener('click', openCart); });
  cartCloseBtns.forEach(function (btn) { btn.addEventListener('click', closeAll); });

  function closeAll() {
    mobileNav && mobileNav.classList.remove('is-open');
    cartDrawer && cartDrawer.classList.remove('is-open');
    closeOverlay();
  }
  overlay && overlay.addEventListener('click', closeAll);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAll();
  });

  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.style.display = count > 0 ? 'flex' : 'none';
    });
  }

  function renderCartLine(item) {
    var variantTitle = item.variant_title && item.variant_title !== 'Default Title'
      ? '<div class="cart-line__price">' + item.variant_title + '</div>' : '';
    return '' +
      '<div class="cart-line" data-cart-line data-key="' + item.key + '">' +
        '<a href="' + item.url + '">' +
          (item.image ? '<img src="' + item.image + '" alt="" width="76" height="76">' : '') +
        '</a>' +
        '<div style="flex:1;">' +
          '<a href="' + item.url + '" class="cart-line__title">' + item.product_title + '</a>' +
          variantTitle +
          '<div class="cart-line__price">' + formatMoney(item.final_price) + '</div>' +
          '<div class="qty-selector">' +
            '<button type="button" data-qty-decrease data-key="' + item.key + '" aria-label="Diminuisci">–</button>' +
            '<input type="text" value="' + item.quantity + '" data-qty-input readonly>' +
            '<button type="button" data-qty-increase data-key="' + item.key + '" aria-label="Aumenta">+</button>' +
          '</div>' +
        '</div>' +
      '</div>';
  }

  function refreshCartDrawer(cart) {
    var itemsWrap = document.querySelector('[data-cart-items]');
    if (!itemsWrap) return;

    if (cart.item_count === 0) {
      itemsWrap.innerHTML = '<div class="cart-empty"><p>Il tuo carrello è vuoto.</p></div>';
    } else {
      itemsWrap.innerHTML = cart.items.map(renderCartLine).join('');
    }

    var subtotalEl = document.querySelector('[data-cart-subtotal]');
    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);

    updateCartCount(cart.item_count);
  }

  function fetchCart() {
    return fetch('/cart.js').then(function (r) { return r.json(); });
  }

  /* Add to cart (product form + sticky ATC) */
  document.querySelectorAll('form[action^="/cart/add"], #ProductForm').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('[data-add-to-cart]');
      if (btn) btn.classList.add('btn--loading');

      var formData = new FormData(form);

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: formData
      })
        .then(function (r) { return r.json(); })
        .then(function () { return fetchCart(); })
        .then(function (cart) {
          refreshCartDrawer(cart);
          openCart();
        })
        .catch(function (err) { console.error('Errore aggiunta al carrello', err); })
        .finally(function () {
          if (btn) btn.classList.remove('btn--loading');
        });
    });
  });

  /* Cart line quantity +/- (drawer + cart page), delegated */
  document.addEventListener('click', function (e) {
    var incBtn = e.target.closest('[data-qty-increase]');
    var decBtn = e.target.closest('[data-qty-decrease]');
    if (!incBtn && !decBtn) return;

    var wrapper = (incBtn || decBtn).closest('.qty-selector');
    var input = wrapper && wrapper.querySelector('[data-qty-input]');
    if (!input) return;

    var value = parseInt(input.value, 10) || 1;
    value = incBtn ? value + 1 : Math.max(0, value - 1);
    input.value = value;

    var key = (incBtn || decBtn).getAttribute('data-key');
    if (key) {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: value })
      })
        .then(function (r) { return r.json(); })
        .then(refreshCartDrawer);
    }
  });

  /* ---------------------------------------------------------------
     Accordion (FAQ, product info)
  --------------------------------------------------------------- */
  document.querySelectorAll('[data-accordion-trigger]').forEach(function (trigger) {
    trigger.addEventListener('click', function () {
      var item = trigger.closest('[data-accordion-item]');
      var panel = item.querySelector('[data-accordion-panel]');
      var isOpen = item.classList.contains('is-open');

      item.classList.toggle('is-open', !isOpen);
      trigger.setAttribute('aria-expanded', String(!isOpen));
      panel.style.maxHeight = !isOpen ? panel.scrollHeight + 'px' : null;
    });
  });

  /* ---------------------------------------------------------------
     Product thumbnails
  --------------------------------------------------------------- */
  var mainImage = document.getElementById('ProductMainImage');
  document.querySelectorAll('[data-product-thumb]').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      document.querySelectorAll('[data-product-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
      if (mainImage) mainImage.src = thumb.getAttribute('data-full');
    });
  });

  /* ---------------------------------------------------------------
     Sticky mobile add-to-cart
  --------------------------------------------------------------- */
  var stickyAtc = document.querySelector('[data-sticky-atc]');
  var productForm = document.getElementById('ProductForm');
  if (stickyAtc && productForm) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        stickyAtc.classList.toggle('is-visible', !entry.isIntersecting);
      });
    }, { threshold: 0 });
    observer.observe(productForm);
  }

  /* ---------------------------------------------------------------
     Cookie banner
  --------------------------------------------------------------- */
  var cookieBanner = document.querySelector('[data-cookie-banner]');
  if (cookieBanner) {
    if (!localStorage.getItem('cookie_consent')) {
      setTimeout(function () { cookieBanner.classList.add('is-visible'); }, 600);
    }
    var accept = cookieBanner.querySelector('[data-cookie-accept]');
    var decline = cookieBanner.querySelector('[data-cookie-decline]');
    accept && accept.addEventListener('click', function () {
      localStorage.setItem('cookie_consent', 'accepted');
      cookieBanner.classList.remove('is-visible');
    });
    decline && decline.addEventListener('click', function () {
      localStorage.setItem('cookie_consent', 'declined');
      cookieBanner.classList.remove('is-visible');
    });
  }

});
